import { get, isFinite } from 'lodash';

import { FIELD_PATHS } from '@funnels/constants';

import { useFormValues } from '..';
import { useDidUpdate } from '../useDidUpdate';

export function useUpdateSecurityValue(assetIndex: number, hasConstructionCosts: boolean) {
  const [formValues, setFormValue] = useFormValues();

  const landValue = get(formValues, FIELD_PATHS.ASSET_LAND_VALUE(assetIndex));
  const buildPrice = get(formValues, FIELD_PATHS.ASSET_BUILD_PRICE_AMOUNT(assetIndex));
  const otherConstructionCosts = get(formValues, FIELD_PATHS.ASSET_OTHER_CONSTRUCTION_COSTS(assetIndex));

  useDidUpdate(() => {
    if (!hasConstructionCosts) {
      setFormValue(FIELD_PATHS.ASSET_CONSTRUCTION_DETAILS(assetIndex), undefined);

      return;
    }

    const securityValue = [landValue, buildPrice, otherConstructionCosts].reduce((acc, curr) => {
      if (!isFinite(curr)) {
        return acc;
      }

      return acc + curr;
    }, 0);

    setFormValue(FIELD_PATHS.ASSET_ESTIMATED_VALUE(assetIndex), securityValue);
  }, [landValue, buildPrice, otherConstructionCosts, hasConstructionCosts, assetIndex]);
}
